import { types, flow, Instance } from 'mobx-state-tree';
import axios from 'server';
import { AxiosResponse } from 'axios';
import { googleProfileInfoModel } from './models/googleProfileInfo.model';

const { model, maybeNull } = types;
export const AppStore = model('AppStore', {
  googleProfileInfo: maybeNull(googleProfileInfoModel),
})
  .actions((self) => ({
    normalizeStore({ data }: AxiosResponse) {
      return self.googleProfileInfo;
    },
  }))
  .volatile(() => ({}))
  .actions((self) => ({
    LdapAttribute: flow(function* () {
      return yield axios
        .get(`/app-attributes/ldap`)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
    }),
    // GoogleAttribute: flow(function* () {
    //   return yield axios
    //     .get(`attribute-preferences/google`)
    //     .then((res) => {
    //       return res.data;
    //     })
    //     .catch((error) => {
    //       throw new Error(error.response.data.data.message);
    //     });
    // }),

    getAttributePreferences: flow(function* (app) {
      return yield axios
        .get(`app-attributes/${app}`)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
    }),
    AttributePreferences: flow(function* (data: { app_name: string; attributes: any[] }) {
      const result = yield axios
        .post(`attribute-preferences`, data)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw new Error(error.response?.data?.message || error.message || 'Request failed');
        });
      return result;
    }),
    // appConnect: flow(function* (appName: string) {
    //   return yield axios
    //     .get(`admin/app/${appName}`)
    //     .then((res) => {
    //       return res.data;
    //     })
    //     .catch((error) => {
    //       throw new Error(error.response.data.data.message);
    //     });
    // }),
    appConnect: flow(function* () {
      try {
        const res = yield axios.get(`apps`);
        return res.data;
      } catch (error: any) {
        throw new Error(error.response?.data?.data?.message || error.message || 'Failed to connect');
      }
    }),
    getConnectedApps: flow(function* () {
      try {
        const res = yield axios.get(`user/connected-apps`);
        return res.data;
      } catch (error: any) {
        throw new Error(
          error.response?.data?.data?.message ||
            error.response?.data?.message ||
            error.message ||
            'Failed to get connected apps'
        );
      }
    }),
    googleConnected: flow(function* () {
      return yield axios
        .get(`admin/app/google/connect`)
        .then((res) => {
          localStorage.setItem('connected', JSON.stringify(res.data.data));
          return res.data;
        })
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
    }),
    providerList: flow(function* () {
      return yield axios
        .get(`apps`)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
    }),
    samlList: flow(function* () {
      return yield axios
        .get(`saml/service-providers`)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
    }),
    zoomConnected: flow(function* () {
      return yield axios
        .get(`admin/app/zoom/connect`)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
    }),
    appReConnect: flow(function* (appName: string) {
      return yield axios
        .get(`apps/${appName}/reconnect`)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
    }),
    googleDisconnected: flow(function* (appName: string) {
      return yield axios
        .delete(`apps/${appName}`)
        .then((res) => {
          return res.data || { success: true, message: `${appName} disconnected successfully` };
        })
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
    }),

    googlelogin: flow(function* () {
      return yield axios
        .get(`auth/social/google`)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
    }),
    GoogleKeyGenrates: flow(function* (data: any) {
      const result = yield axios
        .post<any>(`apps/google`, data)
        .then((response) => {
          return response.data.message;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    AuthenticatorVerify: flow(function* (data: { code: number }) {
      const result = yield axios
        .post(`authenticator/verify`, data)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw new Error(error.response?.data?.message || error.message || 'Request failed');
        });
      return result;
    }),
    // {{base_url}}attribute-preferences/google

    ZoomKeyGenrates: flow(function* (data: any) {
      const result = yield axios
        .post<any>(`apps/zoom`, data)
        .then((response) => {
          return response.data.message;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    MicrosoftKeyGenrates: flow(function* (data: any) {
      const result = yield axios
        .post<any>(`admin/app/microsoft/store`, data)
        .then((response) => {
          return response.data.message;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    googleAuthConnected: flow(function* (location) {
      return yield axios
        .post(`apps/google/callback${location}`)
        .then((res) => {
          self.normalizeStore(res);
          return res;
        })
        .catch((error) => {
          throw new Error(error.response.data.error || error.response.data.data.message);
        });
    }),
    zoomAuthConnected: flow(function* (location) {
      return yield axios
        .post(`apps/zoom/callback${location}`)
        .then((res) => {
          self.normalizeStore(res);
          return res;
        })
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
    }),
    microsoftAuthConnected: flow(function* (location) {
      return yield axios
        .post(`apps/microsoft/callback${location}`)
        .then((res) => {
          self.normalizeStore(res);
          return res;
        })
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
    }),
    githubAuthConnected: flow(function* (location) {
      return yield axios
        .post(`apps/github/callback${location}`)
        .then((res) => {
          self.normalizeStore(res);
          return res;
        })
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
    }),

    googleSsoLink: flow(function* () {
      try {
        const res = yield axios.get(`google-sso/link`);
        return res.data;
      } catch (error: any) {
        console.error('Google SSO Link error:', error);
        throw new Error(error.response?.data?.message || error.message || 'Failed to get Google SSO link');
      }
    }),
    requestAppAccess: flow(function* (provider: string) {
      try {
        const res = yield axios.post(`user/app-access-request`, { provider });
        return res.data;
      } catch (error: any) {
        throw new Error(error.response?.data?.message || error.message || 'Failed to send request');
      }
    }),
  }));

export type IAppStore = Instance<typeof AppStore>;
